var __jsx = React.createElement;
import React, { useState } from 'react';
import Address from '../../../components/atoms/Address';
import { addressMock, inputMock, selectMock } from '../../../utils/themeDemoMockData';
import themes from '../../../themes';
import Anchor from '../../../components/atoms/Anchor';
import Button from '../../../components/atoms/Button';
import FieldError from '../../../components/atoms/FieldError';
import Input from '../../../components/atoms/Input';
import Para from '../../../components/atoms/Para';
import Select from '../../../components/atoms/Select';
import RichText from '../../../components/atoms/RichText';
import SocialIcon from '../../../components/atoms/SocialIcon';
import { socialIcon } from '../../../components/atoms/SocialIcon/SocialIcon.mock';
import * as fonts from '../../../themes/fontfaces';
var Atoms = function Atoms(_ref) {
  var _themes$themeSelected;
  var themeSelected = _ref.themeSelected;
  var theme = (_themes$themeSelected = themes[themeSelected]) !== null && _themes$themeSelected !== void 0 ? _themes$themeSelected : {};
  var _useState = useState(theme),
    testingFont = _useState[0],
    setTestingFont = _useState[1];
  return __jsx(React.Fragment, null, __jsx("h1", null, "Theme Selected: ", themeSelected !== '' ? themeSelected : 'No theme selected'), __jsx("select", {
    onChange: function onChange(e) {
      return setTestingFont(e.target.value);
    }
  }, Object.keys(fonts).map(function (font) {
    return __jsx("option", {
      key: font,
      value: font
    }, font);
  })), __jsx("br", null), __jsx("textarea", {
    style: {
      fontFamily: testingFont,
      fontSize: '2rem',
      fieldSizing: 'normal'
    }
  }), __jsx("section", {
    className: "theme-section"
  }, __jsx("div", null, __jsx("h3", null, "Address"), __jsx(Address, {
    addressLine1: addressMock.line1,
    addressLine2: addressMock.line2,
    city: addressMock.city,
    state: addressMock.region,
    postalCode: addressMock.postalCode
  })), __jsx("div", null)), __jsx("hr", null), __jsx("section", {
    className: "theme-section"
  }, __jsx("div", null, __jsx("h3", null, "Anchor"), __jsx(Anchor, {
    to: "#"
  }, "Test")), __jsx("div", null)), __jsx("hr", null), __jsx("section", {
    className: "theme-section"
  }, __jsx("div", null, __jsx("h3", null, "Button"), __jsx("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: 20
    }
  }, __jsx(Button, {
    styleType: "primary"
  }, "Primary Button"), __jsx(Button, {
    styleType: "secondary"
  }, "Secondary Button"))), __jsx("div", null)), __jsx("hr", null), __jsx("section", {
    className: "theme-section"
  }, __jsx("div", {
    style: {
      paddingBottom: 50
    }
  }, __jsx("h3", null, "FieldError"), __jsx(Input, {
    name: inputMock.name,
    id: inputMock.id,
    label: inputMock.label,
    type: inputMock.type,
    value: "",
    onChange: function onChange() {}
  }), __jsx(FieldError, null, "This is an input field error message")), __jsx("div", null)), __jsx("hr", null), __jsx("section", {
    className: "theme-section"
  }, __jsx("div", null, __jsx("h3", null, "Para"), __jsx(Para, null, "Without message class name."), __jsx(Para, {
    className: "message"
  }, "With message class name.")), __jsx("div", null)), __jsx("hr", null), __jsx("section", {
    className: "theme-section"
  }, __jsx("div", null, __jsx("h3", null, "Select"), __jsx("div", {
    style: {
      width: 300
    }
  }, __jsx(Select, {
    name: selectMock.name,
    options: selectMock.options,
    id: "category",
    label: "Category",
    value: selectMock.options[0].value
  }))), __jsx("div", null)), __jsx("hr", null), __jsx("section", {
    className: "theme-section"
  }, __jsx("div", null, __jsx("h3", null, "Rich Text"), __jsx(RichText, {
    jsonContent: "{\"nodeType\":\"document\",\"data\":{},\"content\":[{\"nodeType\":\"paragraph\",\"data\":{},\"content\":[{\"nodeType\":\"text\",\"value\":\"Lorem ipsum \",\"marks\":[],\"data\":{}},{\"nodeType\":\"hyperlink\",\"data\":{\"uri\":\"#\"},\"content\":[{\"nodeType\":\"text\",\"value\":\"dolor sit amet\",\"marks\":[],\"data\":{}}]},{\"nodeType\":\"text\",\"value\":\", magna.\",\"marks\":[],\"data\":{}}]},{\"nodeType\": \"paragraph\",\"data\": {},\"content\":[{\"nodeType\":\"text\",\"value\":\"Maecenas mi urna, efficitur sit amet. Vestibulum ut magna metus.\",\"marks\":[],\"data\":{}}]}]}"
  })), __jsx("div", null)), __jsx("hr", null), __jsx("section", {
    className: "theme-section"
  }, __jsx("div", null, __jsx("h3", null, "Social Icon"), __jsx(SocialIcon, socialIcon)), __jsx("div", null)), __jsx("hr", null));
};
export default Atoms;